import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const infoOverview: AppRouteModule = {
  path: '/',
  name: '',
  component: LAYOUT,
  redirect: '/info-overview',
  meta: {
    orderNo: 1,
    icon: 'bulletpoint|svg',
    title: t('routes.nurse.infoOverview'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'info-overview',
      name: 'InfoOverview',
      component: () => import('/@/views/nurse/info-overview/index.vue'),
      meta: {
        icon: 'bulletpoint|svg',
        title: t('routes.nurse.infoOverview'),
      },
    },
  ],
};

export default infoOverview;
